import { render } from "./CICS.vue?vue&type=template&id=a871bd68&scoped=true"
import script from "./CICS.vue?vue&type=script&lang=js"
export * from "./CICS.vue?vue&type=script&lang=js"

import "./CICS.vue?vue&type=style&index=0&id=a871bd68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a871bd68"]])

export default __exports__